import { useRef } from 'react'
import { IconButton } from '@mui/material'
import { RoomTypes } from '@weblite/ts-action/room'
import { LiveIcon, MeetIcon } from '$common/icons'
import hostConf from '$config/frontend'
import { useOnboarding } from '$logic/onboarding/react-hooks'
import { CommonOnboarding } from '$logic/onboarding/types'
import { HotSpot } from '$common/tour/components/hot-spot'

const hasCallOption = hostConf.HAS_CALL_OPTION
export function HallAppBarCallElement({
  onClick,
  roomType,
  background,
}: {
  onClick: () => void
  roomType: Extract<RoomTypes, 'CHANNEL' | 'GROUP'>
  background?: string
}) {
  const ref = useRef<HTMLButtonElement>(null)

  const { enabled: onboardingEnabled, completeOnboarding } = useOnboarding(
    CommonOnboarding.HALL_APP_BAR_CALL_BUTTON,
  )

  return roomType === 'CHANNEL' || hasCallOption ? (
    <IconButton
      ref={ref}
      sx={{
        marginLeft: '4px',
        position: 'relative',
      }}
      onClick={() => {
        onClick()
        completeOnboarding()
      }}
    >
      {onboardingEnabled && (
        <HotSpot
          sx={{ position: 'absolute', top: '2px', right: 0 }}
          containerRef={ref}
        />
      )}
      {roomType === 'GROUP' ? (
        <MeetIcon sx={{ color: background ? 'neutral000' : 'neutral700' }} />
      ) : (
        <LiveIcon sx={{ color: background ? 'neutral000' : 'neutral700' }} />
      )}
    </IconButton>
  ) : null
}
